export default __webpack_public_path__ + "static/media/terminoliesIcon.b9591b2a.svg";